import React from 'react';
export function FAQSection() {
  const faqs = [{
    question: 'Wird meine Kanzleisoftware unterstützt?',
    answer: 'Legallama lässt sich derzeit (Stand 11/25) mit den Kanzlei-Lösungen xxx, xxx, xxx und xxx verbinden. Wir entwickeln unsere Lösung stets weiter.'
  }, {
    question: 'Ist die Nutzung datenschutzrechtlich unbedenklich?',
    answer: 'Ja. Alle Daten bleiben in Deutschland, auf unseren eigenen Servern. Keine Übertragung an Drittanbieter. Vollständig DSGVO-konform.'
  }, {
    question: 'Welche KI wird eingesetzt?',
    answer: 'Wir verwenden selbst entwickelte, lokal betriebene juristische LLMs – speziell für Verkehrsrecht.'
  }, {
    question: 'Wie lange dauert die Einrichtung?',
    answer: 'Die Einrichtung dauert ca. 2h und eine Bedienungseinweisung ca. 1h. Darüber hinaus stehen Ihren Mitarbeitenden Schulungsvideos zur Verfügung. Sie können also noch am gleichen Tag starten.'
  }, {
    question: 'Was ist der Unterschied zu ChatGPT & Co.?',
    answer: 'Kein Datenabfluss, keine Cloud, kein Risiko. Legallama ist eine spezialisierte juristische Automatisierungsplattform – kein generisches AI-Tool.'
  }];
  return <section className="py-20 bg-white" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-25">
          <h2 id="faq" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-26">
            Häufig gestellte Fragen
          </h2>
        </div>
        <div className="max-w-3xl mx-auto space-y-6" data-id="element-27">
          {faqs.map((faq, index) => <div key={index} className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-28">
              <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-start gap-2" data-id="element-29">
                <span className="text-blue-600" data-id="element-30">❓</span>
                {faq.question}
              </h3>
              <p className="text-gray-700 pl-7" data-id="element-31">{faq.answer}</p>
            </div>)}
        </div>
      </div>
    </section>;
}